let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g1Xnf")).then(() => parcelRequire('1Pa7M'));